import React, { useState } from 'react';
import './product-offers-sort.scss';
import ProductOffersDropdown from 'components/product/product-offers-dropdown/product-offers-dropdown';
import { SortType } from '../../../../reducers/offers';
import useToggle from 'hooks/use-toggle';

interface ProductOffersSortProps {
    onSortChange: (value: SortType) => void;
}

const ProductOffersSort: React.FC<ProductOffersSortProps> = ({ onSortChange }) => {
    const [isOpen, toggleIsOpen] = useToggle();
    const [selected, setSelected] = useState<SortType>(SortType.BestOffer);
    const dropdownList = [
        {
            label: 'Sortuj wg: Najlepsze oferty',
            isActive: true,
            value: SortType.BestOffer,
            gtm: 'gtm_osrt_bst'
        },
        {
            label: 'Sortuj wg: Cena',
            isActive: true,
            value: SortType.Price,
            gtm: 'gtm_osrt_prc'
        },
        {
            label: 'Sortuj wg: Oceny sklepu',
            isActive: true,
            value: SortType.ShopScore,
            gtm: 'gtm_osrt_rnk'
        }
    ];

    const onSelect = (value: string): void => {
        setSelected(value as SortType);
        onSortChange(`OFFERS_${value}` as unknown as SortType);
        toggleIsOpen.setToggleState(false);
    };

    const onBlur = (event: React.FocusEvent<HTMLElement>): void => {
        const currentElement = event.currentTarget;
        setTimeout(() => {
            if (!currentElement.contains(document.activeElement)) {
                toggleIsOpen.setToggleState(false);
            }
        }, 100);
    };

    return (
        <div className="product-offers-sort">
            <ProductOffersDropdown
                onBlur={onBlur}
                onToggle={toggleIsOpen.toggle}
                isOpen={isOpen}
                dropdownList={dropdownList}
                value={[selected]}
                onSelect={onSelect}
                onClose={(): void => toggleIsOpen.setToggleState(false)}
            >
                <i className="icon-main icon-sort"/>
                {''}
                Sortuj
                <i className={isOpen ? 'icon-arr1-up' : 'icon-arr1-down'}/>
            </ProductOffersDropdown>
        </div>
    );
};

export default ProductOffersSort;
